import { render, staticRenderFns } from "./detailUser.vue?vue&type=template&id=353bb214&scoped=true&"
import script from "./detailUser.vue?vue&type=script&lang=js&"
export * from "./detailUser.vue?vue&type=script&lang=js&"
import style0 from "./detailUser.vue?vue&type=style&index=0&id=353bb214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353bb214",
  null
  
)

export default component.exports